var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "donation-form insicht insicht--fade-up" }, [
    _c(
      "form",
      {
        staticClass: "donation-form__wrapper",
        attrs: { novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onSubmit.apply(null, arguments)
          }
        }
      },
      [
        _vm.title
          ? _c("h2", {
              directives: [
                {
                  name: "sanitize",
                  rawName: "v-sanitize",
                  value: _vm.title,
                  expression: "title"
                }
              ],
              staticClass: "donation-form__title"
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.subtitle
          ? _c("h3", {
              directives: [
                {
                  name: "sanitize",
                  rawName: "v-sanitize",
                  value: _vm.subtitle,
                  expression: "subtitle"
                }
              ],
              staticClass: "donation-form__subtitle"
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.response.message
          ? _c("GeneralMessage", {
              ref: "message",
              attrs: {
                message: _vm.response.message,
                type: _vm.response.type,
                stick: ""
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "donation-form__amount" }, [
          _c("span", {
            staticClass: "donation-form__amount-prefix",
            domProps: { innerHTML: _vm._s("CHF") }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.amount,
                expression: "amount",
                modifiers: { number: true }
              }
            ],
            staticClass: "donation-form__amount-input",
            attrs: {
              type: "number",
              min: "0",
              step: "1",
              autocomplete: "off",
              disabled: _vm.formLocked
            },
            domProps: { value: _vm.amount },
            on: {
              blur: [
                _vm.onBlur,
                function($event) {
                  return _vm.$forceUpdate()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.amount = _vm._n($event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("Button", {
          attrs: {
            type: "submit",
            level: "primary",
            text: _vm.$t("donation.orderButton"),
            disabled: _vm.submitLocked
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }